<div class="fast-checkin-duration-container">
  <div class="content-wrapper mt-4">
    <div class="row">
      <div class="col-12">
        <div class="form-row row">
          <div class="form-group col-md-12">
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ 'i18n.shared.fields.zone' | translate }}</span>
              <strong>{{ sessionInfo.zone?.name }}</strong>
            </div>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ 'i18n.shared.fields.control-plate' | translate }}</span>
              <strong>{{ sessionInfo.controlPlateNumber }}</strong>
            </div>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ 'i18n.domain.fast-checkin-session.start-time' | translate }}</span>
              <strong>{{ sessionInfo.startDateTime?.toFormat('dd.MM.yyyy HH:mm') }}</strong>
            </div>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ 'i18n.domain.fast-checkin-session.end-time' | translate }}</span>
              <strong>{{ sessionInfo.endDateTime?.toFormat('dd.MM.yyyy HH:mm') }}</strong>
            </div>
          </div>
        </div>
        <div class="form-row row">
          <div class="form-group col-md-12">
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ 'i18n.domain.fast-checkin-session.total-price' | translate }}</span>
              <strong class="text-primary">{{ sessionPriceWithCurrency }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if(showExtensionSettings) {
      <hr class="my-3">
      <div class="form-row row mt-2">
        <div class="form-group col-md-12">
          <div class="d-flex justify-content-between">
            <span class="text-muted">{{ 'i18n.domain.fast-checkin-session.max-extension-duration' | translate }}</span>
            <strong>{{ formatDuration(maxExtensionDurationMinutes) }}</strong>
          </div>
        </div>
      </div>

      <div class="form-row row">
        <div class="form-group col-md-12">
          <div class="d-flex justify-content-between">
            <span class="text-muted">{{ 'i18n.domain.fast-checkin-session.extension-price' | translate }}</span>
            <strong class="text-primary">
              @if(isExtensionPriceLoading) {
                ...
              } @else {
                {{ extensionPriceWithCurrency || '-' }}
              }
            </strong>
          </div>
        </div>
      </div>

      <app-fast-checkin-time-settings
        [startTime]="extensionStartTime"
        [durationMinutes]="extensionDurationMinutes"
        [maxDurationMinutes]="maxExtensionDurationMinutes ?? 1440"
        [minDurationMinutes]="maxExtensionDurationMinutes != null && maxExtensionDurationMinutes < 5 ? maxExtensionDurationMinutes : 5"
        [translationPrefix]="'i18n.domain.fast-checkin-session'"
        (durationMinutesChange)="onExtensionDurationChanged($event)"></app-fast-checkin-time-settings>

      <div class="form-row row mt-2">
        <div class="form-group col-6">
          <div class="d-grid">
            <button type="button" class="btn btn-outline-primary" (click)="onCancelExtensionSettings()">
              {{ 'i18n.shared.cancel' | translate }}
            </button>
          </div>
        </div>
        <div class="form-group col-6">
          <div class="d-grid">
            <button type="button" class="btn btn-primary" [disabled]="isExtensionPriceLoading || !extensionPriceWithCurrency || extensionDurationMinutes <= 0" (click)="onApplyExtensionSettings()">
              {{ 'i18n.domain.fast-checkin-session.extend-now' | translate }}
            </button>
          </div>
        </div>
      </div>
    }

    <div class="button-container">
      <div class="d-grid">
        @if(sessionInfo.isSessionExtendable && hasAvailableExtensionDuration && !showExtensionSettings) {
          <button class="btn btn-outline-primary mb-2" (click)="onOpenExtensionSettings()">
            {{ 'i18n.domain.fast-checkin-session.extend-session' | translate }}
          </button>
        }
        <button class="btn btn-danger" (click)="checkOut.emit()">
          {{ 'i18n.domain.fast-checkin-session.close-session' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
